export const WELCOME_VISITED_KEY = 'kph_welcome_visited';
